import { client } from '../utils'
import { people as endpoints } from '../api_urls'

export const updatePeople = peopleData => ({
  type: 'UPDATE_PEOPLE_DATA',
  payload: peopleData,
})

export const updateArchivedMembers = payload => ({
  type: 'UPDATE_ARCHIVED_MEMBERS',
  payload: payload,
})

export const updateSections = sectionData => ({
  type: 'UPDATE_SECTIONS',
  payload: sectionData,
})

export const updateAllSections = allSectionData => ({
  type: 'UPDATE_ALL_SECTIONS',
  payload: allSectionData,
})

export const updateToBeArchivedMembers = payload => ({
  type: 'UPDATE_TO_BE_ARCHIVED_MEMBERS',
  payload: payload,
})

export const updateCourseMemPage = payload => ({
  type: 'UPDATE_COURSE_MEMBER_PAGE',
  payload: payload,
})

export const updateArchiveMemPage = payload => ({
  type: 'UPDATE_ARCHIVED_MEMBER_PAGE',
  payload: payload,
})

export const updateSectionPage = payload => ({
  type: 'UPDATE_SECTION_PAGE',
  payload: payload,
})

export const updateActivePeopleCount = payload => ({
  type: 'UPDATE_ACTIVE_COUNT',
  payload: payload,
})

export const updateArchivedPeopleCount = payload => ({
  type: 'UPDATE_ARCHIVED_COUNT',
  payload: payload,
})

export const updateSectionCount = payload => ({
  type: 'UPDATE_SECTION_COUNT',
  payload: payload,
})

export const setFilters = payload => ({
  type: 'UPDATE_FILTERS',
  payload: payload,
})

export const resetFilters = () => ({
  type: 'RESET_FILTERS',
})

export const updatePageNum = payload => {
  return async dispatch => {
    // payload includes page number, table name, and filters if applicable
    try {
      let resp = await client.post(`${endpoints.paginatePeople()}`, payload)
      switch (payload.table) {
        case 'courseMember':
          dispatch(updateCourseMemPage(payload.page))
          dispatch(updatePeople(resp.data.peopleData))
          dispatch(updateActivePeopleCount(resp.data.peopleCount))
          break
        case 'archivedMember':
          dispatch(updateArchiveMemPage(payload.page))
          dispatch(updateArchivedMembers(resp.data.archivedData))
          dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
          break
        case 'section':
          dispatch(updateSectionPage(payload.page))
          dispatch(updateSections(resp.data.sectionData))
          dispatch(updateSectionCount(resp.data.sectionCount))
          break
        default:
          return null
      }
    } catch (err) {
      console.error(`Error getting paginated data for ${payload.table}`, err)
    }
  }
}

export const newSection = (name, offset) => {
  return async dispatch => {
    let url = endpoints.newSection()
    try {
      let response = await client.post(url, {
        section_title: name,
        time_offset: offset,
      })
      dispatch(updateSectionPage(1))
      dispatch(updateSections(response.data.sectionData))
      dispatch(updateSectionCount(response.data.sectionCount))
      dispatch(updateAllSections(response.data.allSectionData))
      return response
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return err.response
    }
  }
}

export const addPeople = data => {
  return async dispatch => {
    let url = endpoints.addPeople()

    try {
      let resp = await client.post(url, data)
      if (resp.data.peopleData.length >= 0) {
        dispatch(updatePeople(resp.data.peopleData))
      } else {
        throw new Error('Problem with active people objects.')
      }
      if (resp.data.peopleCount >= 0) {
        dispatch(updateActivePeopleCount(resp.data.peopleCount))
      } else {
        throw new Error('Problem with active people count.')
      }
      if (resp.data.archiveData.length >= 0) {
        dispatch(updateArchivedMembers(resp.data.archiveData))
      } else {
        throw new Error('Problem with archived people objects.')
      }
      if (resp.data.archivedCount >= 0) {
        dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
      } else {
        throw new Error('Problem with archived people count.')
      }
      dispatch(updateCourseMemPage(resp.data.courseMemPage))
      dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
      return resp
    } catch (err) {
      console.error(`Error: ${err}`)
    }
  }
}

export const tempAccess = data => {
  return async dispatch => {
    let url = endpoints.tempAccess()
    try {
      var resp = await client.post(url, data)
      dispatch(updatePeople(resp.data.peopleData))
      dispatch(updateActivePeopleCount(resp.data.peopleCount))
      dispatch(updateArchivedMembers(resp.data.archiveData))
      dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
      dispatch(updateCourseMemPage(resp.data.courseMemPage))
      dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
      return resp
    } catch (err) {
      console.error(`Error fetching ${url}.`, err)
    }
  }
}

export const saveNewSectionName = payload => {
  return async dispatch => {
    try {
      let resp = await client.post(endpoints.editSectionName(), payload)
      dispatch(updateSections(resp.data.sectionData))
      dispatch(updateAllSections(resp.data.allSectionData))
      dispatch(updatePeople(resp.data.peopleData))
      dispatch(updateActivePeopleCount(resp.data.peopleCount))
      dispatch(updateCourseMemPage(resp.data.courseMemPage))
      dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
      dispatch(updateArchivedMembers(resp.data.archiveData))
      dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
      return resp
    } catch (err) {
      return err.response
    }
  }
}

export const removeSection = payload => {
  return async dispatch => {
    let resp = await client.post(endpoints.removeSection(), payload)
    dispatch(updateSections(resp.data.sectionData))
    dispatch(updateAllSections(resp.data.allSectionData))
    dispatch(updatePeople(resp.data.peopleData))
    dispatch(updateActivePeopleCount(resp.data.peopleCount))
    dispatch(updateArchivedMembers(resp.data.archiveData))
    dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
    dispatch(updateCourseMemPage(resp.data.courseMemPage))
    dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
    dispatch(updateSectionPage(1))
    dispatch(updateSectionCount(resp.data.sectionCount))
    return resp
  }
}

export const setExpirationDate = payload => {
  return async dispatch => {
    let resp = await client.post(endpoints.setExpirationDate(), payload)
    dispatch(updateSections(resp.data.sectionData))
    dispatch(updateAllSections(resp.data.allSectionData))
    return resp
  }
}

export const archiveMembers = memberList => {
  return async dispatch => {
    let url = endpoints.archiveMembers()
    try {
      var resp = await client.post(url, memberList)
      dispatch(updatePeople(resp.data.peopleData))
      dispatch(updateActivePeopleCount(resp.data.peopleCount))
      dispatch(updateArchivedMembers(resp.data.archiveData))
      dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
      dispatch(updateToBeArchivedMembers([]))
      dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
      dispatch(updateCourseMemPage(resp.data.courseMemPage))
      return resp
    } catch (err) {
      console.error(err)
    }
  }
}

export const unarchiveCourseMember = payload => {
  return async dispatch => {
    let resp = await client.post(endpoints.unarchiveCourseMember(), payload)
    dispatch(updatePeople(resp.data.peopleData))
    dispatch(updateActivePeopleCount(resp.data.peopleCount))
    dispatch(updateArchivedMembers(resp.data.archiveData))
    dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
    dispatch(updateCourseMemPage(resp.data.courseMemPage))
    dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
    return resp
  }
}

export const removeCourseMember = payload => {
  return async dispatch => {
    try {
      let resp = await client.post(endpoints.removeCourseMember(), payload)
      dispatch(updatePeople(resp.data.peopleData))
      dispatch(updateActivePeopleCount(resp.data.peopleCount))
      dispatch(updateArchivedMembers(resp.data.archiveData))
      dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
      dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
      dispatch(updateCourseMemPage(resp.data.courseMemPage))
      return resp
    } catch (err) {
      return {
        status: err.response.status,
        message: err.response.data.error,
      }
    }
  }
}

export const fixLmsId = payload => {
  return async () => {
    try {
      let resp = await client.post(endpoints.fixLmsId(), payload)
      return resp
    } catch (err) {
      return {
        status: err.response.status,
        message: err.response.data.error,
      }
    }
  }
}

export const uploadGradesToLms = payload => {
  return async () => {
    try {
      let resp = await client.post(endpoints.uploadGradesToLms(), payload)
      return resp
    } catch (err) {
      return {
        status: err.response.status,
        message: err.response.data.error,
      }
    }
  }
}

export const forceReadingAnalytics = payload => {
  return () => client.post(endpoints.forceReadingAnalytics(), payload)
}

export const forceVideoAnalytics = payload => {
  return () => client.post(endpoints.forceVideoAnalytics(), payload)
}

export const filterPeople = payload => {
  return async dispatch => {
    let url = endpoints.getTableData()
    let resp = await client.post(url, payload)
    dispatch(updatePeople(resp.data.active))
    dispatch(updateArchivedMembers(resp.data.archived))
    dispatch(updateActivePeopleCount(resp.data.peopleCount))
    dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
    dispatch(updateCourseMemPage(resp.data.courseMemPage))
    dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
    return resp
  }
}

export const archiveSection = payload => {
  return async dispatch => {
    let resp = await client.post(endpoints.archiveSection(), payload)
    dispatch(updatePeople(resp.data.peopleData))
    dispatch(updateActivePeopleCount(resp.data.peopleCount))
    dispatch(updateArchivedMembers(resp.data.archiveData))
    dispatch(updateArchivedPeopleCount(resp.data.archivedCount))
    dispatch(updateCourseMemPage(resp.data.courseMemPage))
    dispatch(updateArchiveMemPage(resp.data.archivedMemPage))
    return resp
  }
}

export const bulkFixLmsIds = payload => {
  return async () => {
    let resp = await client.post(endpoints.bulkUpdateLmsIds(), payload)
    return resp
  }
}

export const bulkUploadGrades = payload => {
  return async () => {
    let resp = await client.post(endpoints.bulkUploadGrades(), payload)
    return resp
  }
}
